export const projects = [
  {
    name: "Cryptocurrencies application",
    nameRu: "Криптовалюта",
    description:
      "The cryptocurrency application displays a list of the most popular cryptocurrencies, a price chart and detailed information for each cryptocurrency.",
    descriptionRu:
      "Приложение о криптовалюте, отображает список  самых популярных криптовалют, график изменения цен и подробную информацию по каждой криптовалюте.",
    fullDescription:
      "The cryptocurrency application displays a list of the most popular cryptocurrencies, a price chart and detailed information for each cryptocurrency.",
    fullDescriptionRu:
      "Приложение о криптовалюте, отображает список  самых популярных криптовалют, график изменения цен и подробную информацию по каждой криптовалюте.",
    tools: [
      "React: hooks, react-route-dom",
      "Redux Toolkit",
      "RTK Query",
      "Rapid API",
      "Ant Design",
      "chart.js, react-chart-js-2",
      "millify",
      "moment"
    ],
    image: "Cryptocurrency",
    github: "https://github.com/chingisdorzhiev/cryptocurrencies",
    link: "https://chingisdorzhiev.github.io/cryptocurrencies/",
  },
  {
    name: "Chess",
    nameRu: "Шахматы",
    description:
      "Classic chess, written in TypeScript, the basic logic of moving pieces, eating pieces and highlighting possible moves is implemented, using OOP.",
    descriptionRu:
      "Классические шахматы, написаны на TypeScript, реализована базовая логика движения фигур, поедания фигур и подсветка возможных ходов, с применением ООП.",
    fullDescription:
      "Classic chess, written in TypeScript, the basic logic of moving pieces, eating pieces and highlighting possible moves is implemented, using OOP.",
    fullDescriptionRu:
      "Классические шахматы, написаны на TypeScript, реализована базовая логика движения фигур, поедания фигур и подсветка возможных ходов, с применением ООП.",
    tools: [
      "React",
      "TypeScript",
      "OOP",
    ],
    image: "Chess",
    github: "https://github.com/chingisdorzhiev/chess",
    link: "https://chingisdorzhiev.github.io/chess",
  },
  {
    name: "Music App",
    nameRu: "Музыкальное приложение",
    description:
      "Application for playing music. Implemented track search and rewinding.",
    descriptionRu:
      "Приложение по воспроизведению музыку. Реализован поиск треков и перемотка.",
    fullDescription:
      "Application for playing music. Implemented track search and rewinding.",
    fullDescriptionRu:
      "Приложение по воспроизведению музыку. Реализован поиск треков и перемотка.",
    tools: [
      "Vite",
      "React",
      "React Context API",
      "SCSS",
      "Material UI"
    ],
    image: "Music",
    github: "https://github.com/chingisdorzhiev/music-app",
    link: "https://chingisdorzhiev.github.io/music-app",
  },
  {
    name: "Portfolio Website",
    nameRu: "Сайт Портфолио",
    description:
      "A portfolio site written on the React library using the Redux state management library",
    descriptionRu:
      "Сайт портфолио, написанный на библиотеке React с применением библиотеки управления состоянием Redux",
    fullDescription:
      "A portfolio website written in the React library. Changing light and dark mode is implemented using Redux state management library. The form for sending a message is implemented using Formik library and EmailJS resource. Also the site has adaptive and responsive layout, so you can watch the site on your mobile device.",
    fullDescriptionRu:
      "Сайт портфолио, написанный на библиотеке React. Смена светлой и темной темы реализована с применением библиотеки управления состоянием Redux. Форма для отправки сообщения реализована с применением библиотеки Formik и ресурса EmailJS. Также сайт имеет адаптивную и отзывчивую верстку, поэтому вы можете просмотреть сайт на своем мобильном устройстве.",
    tools: [
      "React",
      "Redux",
      "Formik",
      "EmailJS API",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    image: "Portfolio",
    github: "https://github.com/chingisdorzhiev/portfolio",
    link: "https://chingisdorzhiev.github.io/portfolio",
  },
  {
    name: "Quiz App",
    nameRu: "Квиз",
    description: "A quiz on rock classics with a single answer choice",
    descriptionRu: "Квиз на знание рок-классики с единственным выбором ответа",
    fullDescription:
      "A quiz on rock classics with a single answer choice. At the end of the quiz you will see your score.",
    fullDescriptionRu:
      "Квиз на знание рок-классики с единственным выбором ответа. По завершению квиза вы увидите набранное вами количество очков.",
    tools: ["HTML", "CSS", "JavaScript"],
    image: "QuizApp",
    github: "https://github.com/chingisdorzhiev/quizz",
    link: "https://chingisdorzhiev.github.io/quizz/",
  },
  {
    name: "Snake",
    nameRu: "Змейка",
    description: "The classic snake game",
    descriptionRu: "Классическая игра Змейка",
    fullDescription: "The classic snake game. Implemented using Canvas API.",
    fullDescriptionRu:
      "Классическая игра Змейка. Реализована с использованием Canvas API.",
    tools: ["HTML", "CSS", "JavaScript", "Canvas API"],
    image: "Snake",
    github: "https://github.com/chingisdorzhiev/snake",
    link: "https://chingisdorzhiev.github.io/snake/",
  },
  {
    name: "Timer",
    nameRu: "Таймер",
    description: "Classic timer with the ability to set the time to count down",
    descriptionRu:
      "Классический таймер с возможностью устанавливать время для отсчета.",
    fullDescription:
      "Classic timer with the ability to set the time to count down.",
    fullDescriptionRu:
      "Классический таймер с возможностью устанавливать время для отсчета.",
    tools: ["HTML", "CSS", "JavaScript"],
    image: "Timer",
    github: "https://github.com/chingisdorzhiev/timer",
    link: "https://chingisdorzhiev.github.io/timer/",
  },
  {
    name: "Calculator",
    nameRu: "Калькулятор",
    description: "A simple calculator performs all standard math operations",
    descriptionRu:
      "Простой калькулятор выполняет все стандартные математические операции",
    fullDescription:
      "A simple calculator performs all standard math operations. Rounding of large numbers, changing font size depending on the number of characters, etc. are implemented.",
    fullDescriptionRu:
      "Простой калькулятор выполняет все стандартные математические операции. Реализовано округление больших чисел, изменение размера шрифта в зависимости от количества символов и пр.",
    tools: ["HTML", "CSS", "JavaScript"],
    image: "Calculator",
    github: "https://github.com/chingisdorzhiev/calculator",
    link: "https://chingisdorzhiev.github.io/calculator/",
  },
  {
    name: "Countdown Timer",
    nameRu: "Таймер обратного отсчета",
    description: "A countdown timer to the much-loved Christmas",
    descriptionRu: "Таймер обратного отсчета до любимым многими рождества",
    fullDescription:
      "A countdown timer to the much-loved Christmas. Christmas balls animation with CSS animation is implemented for the background.",
    fullDescriptionRu:
      "Таймер обратного отсчета до любимого многими рождества. Для фона реализована анимация рождественских шариков при помощи CSS анимации.",
    tools: ["HTML", "CSS", "JavaScript", "@Keyframes"],
    image: "Countdown",
    github: "https://github.com/chingisdorzhiev/countdown",
    link: "https://chingisdorzhiev.github.io/countdown/",
  },
  {
    name: "Weather App",
    nameRu: "Приложение Погода",
    description: "An app that shows the weather in a specified city",
    descriptionRu: "Приложение, показывающее погоду в указанном городе",
    fullDescription:
      "An app that shows the weather in a specified city. Shows the main indicators: temperature, humidity and wind speed.",
    fullDescriptionRu:
      "Приложение, показывающее погоду в указанном городе. Показывает основные показатели: температуру, влажность и скорость ветра.",
    tools: ["HTML", "CSS", "JavaScript", "Fetch API"],
    image: "WeatherApp",
    github: "https://github.com/chingisdorzhiev/weather",
    link: "https://chingisdorzhiev.github.io/weather/",
  },

  {
    name: "Stopwatch",
    nameRu: "Секундомер",
    description: "Standard stopwatch for timing",
    descriptionRu: "Стандартный секундомер для замера времени",
    fullDescription: "Standard stopwatch for timing",
    fullDescriptionRu: "Стандартный секундомер для замера времени",
    tools: ["HTML", "CSS", "JavaScript"],
    image: "Stopwatch",
    github: "https://github.com/chingisdorzhiev/stopwatch",
    link: "https://chingisdorzhiev.github.io/stopwatch/",
  },
  {
    name: "Drawing App",
    nameRu: "Приложение для рисования",
    description: "A simple drawing app",
    descriptionRu:
      "Простое приложение для рисования. Реализовано с использованием Canvas API.",
    fullDescription: "A simple drawing app. Implemented using Canvas API.",
    fullDescriptionRu:
      "Простое приложение для рисования. Реализовано с использованием Canvas API.",
    tools: ["HTML", "CSS", "JavaScript", "Canvas API"],
    image: "DrawingApp",
    github: "https://github.com/chingisdorzhiev/draw",
    link: "https://chingisdorzhiev.github.io/draw/",
  },
];
